<template>
  <div class="upgrade-page pk-account-panel">
    <section class="upgrade-hero">
      <div class="hero-title">
        <div class="hero-title-copy">
          <span class="upgrade-title-icon"></span>
          <h1>升级</h1>
          <button class="guide-button" @click="showGuide">怎么玩？</button>
        </div>
        <div class="history-actions">
          <button @click="goHistory">升级历史</button>
          <button @click="goMyHistory">我的升级历史</button>
        </div>
      </div>

      <div class="upgrade-board">
        <div class="upgrade-side">
          <span>选择您的物品</span>
          <div class="empty-inventory">
            <b>{{ loggedIn ? '选择库存饰品或使用余额' : '登录后选择库存饰品' }}</b>
            <p>物品选择区展示当前账户库存，升级结果以页面实际结果为准。</p>
          </div>
          <div class="source-switch">
            <button :class="{ active: sourceMode === 'items' }" @click="sourceMode = 'items'">物品</button>
            <button :class="{ active: sourceMode === 'pizza' }" @click="sourceMode = 'pizza'">比萨</button>
          </div>
          <div class="selected-line">
            <span>所选物品: 0/20</span>
            <strong>0.00 <i></i></strong>
          </div>
        </div>

        <div class="upgrade-center">
          <div class="range-line">滚动范围: 0 - 0</div>
          <div class="chance-dial">
            <div class="dial-core">0%</div>
          </div>
          <div class="arrow-row">
            <span></span>
            <b>选择物品</b>
            <span></span>
          </div>
        </div>

        <div class="upgrade-side target-side">
          <span>升级</span>
          <div class="empty-inventory target-placeholder">
            <b>选择目标饰品</b>
            <p>从下方列表选择你想升级获得的饰品。</p>
          </div>
          <div class="selected-line">
            <span>商品价格</span>
            <strong>0.00 <i></i></strong>
          </div>
        </div>
      </div>

      <section class="upgrade-controls">
        <div class="roll-direction">
          <button :class="{ active: rollDirection === 'down' }" @click="rollDirection = 'down'">往下滚 ↓</button>
          <button :class="{ active: rollDirection === 'up' }" @click="rollDirection = 'up'">往上涨 ↑</button>
        </div>
        <div class="multiplier-control">
          <span>获胜机会<br /><b>0%</b></span>
          <button v-for="item in multipliers" :key="item" :class="{ active: multiplier === item }" @click="multiplier = item">{{ item }}</button>
          <span>乘数<br /><b>{{ multiplier }}</b></span>
        </div>
        <div class="balance-control">
          <span>使用余额</span>
          <div><i></i></div>
          <b>0</b>
        </div>
      </section>
    </section>

    <section class="upgrade-filter">
      <div class="type-strip">
        <button
          v-for="(item, index) in selList"
          :key="item.id"
          :class="{ active: item.id == classId }"
          @click="selOran(item.status, item.id)"
        >
          <img :src="typeImageUrl(item.img, index)" :data-fallback="skinFallbackImages[index % skinFallbackImages.length]" alt="" @error="replaceTypeImage" />
          <span>{{ item.name }}</span>
        </button>
      </div>

      <div v-if="classList.length" class="subclass-strip">
        <button
          v-for="item in classList"
          :key="item.id"
          :class="{ active: item.id == subClassId }"
          @click="selClass(item)"
        >
          {{ item.name }}
        </button>
      </div>

      <div class="filter-actions">
        <button class="sort-btn" @click="onHandledSort">价格 {{ sortText }}</button>
        <el-input
          v-model="searchKey"
          class="upgrade-search"
          placeholder="按名称搜索"
          @keyup.enter.native="getList"
        >
          <i slot="suffix" class="el-input__icon el-icon-search" @click="getList"></i>
        </el-input>
      </div>
    </section>

    <section class="target-list">
      <article v-for="(item, index) in list" :key="item.id" class="target-card" @click="goOrnamentOpen(item)">
        <em>{{ item.exteriorName }}</em>
        <div class="skin-visual">
          <img :src="item.imageUrl" alt="" @error="useSkinFallback($event, index)" />
        </div>
        <strong :title="item.itemName">{{ item.itemName }}</strong>
        <span>{{ moneyText(item.price) }} <i></i></span>
      </article>
    </section>

    <div v-if="!list.length" class="empty-card">暂无可升级目标饰品。</div>
  </div>
</template>

<script>
export default {
  props: ["yidongmenu", "showNav", "openHongbao"],
  data() {
    return {
      page: 1,
      pageSize: 100,
      list: [],
      classList: [],
      selList: [],
      sortType: "",
      searchKey: "",
      rarity: "不限",
      exterior: "不限",
      classId: "1",
      subClassId: "all",
      recommend: 1,
      sourceMode: "items",
      rollDirection: "down",
      multiplier: "1.2X",
      multipliers: ["1X", "1.2X", "2X", "5X"],
      skinFallbackImages: [
        require("../assets/hotpizza/hp-ak-green.png"),
        require("../assets/hotpizza/hp-m4-blue.png"),
        require("../assets/hotpizza/hp-awp-fire.png"),
        require("../assets/hotpizza/hp-gloves.png"),
      ],
      skinImageCache: {
        809: require("../assets/skin-cache/pizzaset-809.png"),
        658: require("../assets/skin-cache/pizzaset-658.png"),
        759: require("../assets/skin-cache/pizzaset-759.png"),
        827: require("../assets/skin-cache/ornament-827.png"),
        663: require("../assets/skin-cache/ornament-663.png"),
        842: require("../assets/skin-cache/ornament-842.png"),
        844: require("../assets/skin-cache/ornament-844.png"),
        847: require("../assets/skin-cache/ornament-847.png"),
        849: require("../assets/skin-cache/ornament-849.png"),
        850: require("../assets/skin-cache/ornament-850.png"),
      },
    };
  },
  computed: {
    loggedIn() {
      return Boolean(this.$store.state.token || localStorage.getItem("token"));
    },
    sortText() {
      if (this.sortType == "asc") return "从低到高";
      if (this.sortType == "desc") return "从高到低";
      return "默认";
    },
  },
  watch: {
    searchKey(value) {
      if (value.length == 0) {
        this.getList();
      }
    },
    classId(value) {
      if (!value) return;
      this.classList = [{ name: "全部", id: "all" }];
      this.subClassId = "all";
      this.$axios.post("/index/Lucky/subclassList", this.$qs.stringify({ type_id: value })).then((res) => {
        if (res.data.status && res.data.data.list) {
          this.classList.push(...res.data.data.list);
        }
      });
    },
  },
  mounted() {
    this.getList();
    this.getListClass();
  },
  methods: {
    typeImageUrl(url, index) {
      const image = String(url || "");
      if (image.indexOf("standoffi.oss-cn-hongkong.aliyuncs.com") !== -1) {
        return this.skinFallbackImages[index % this.skinFallbackImages.length];
      }
      return image || this.skinFallbackImages[index % this.skinFallbackImages.length];
    },
    replaceTypeImage(event) {
      event.target.src = event.target.dataset.fallback;
    },
    onHandledSort() {
      if (this.sortType == "") {
        this.sortType = "asc";
      } else if (this.sortType == "asc") {
        this.sortType = "desc";
      } else {
        this.sortType = "";
      }
      this.getList();
    },
    getListClass() {
      this.$axios.post("/index/Lucky/luckyTypeList").then((res) => {
        if (res.data.status == 1) {
          this.selList = res.data.data;
        }
      });
    },
    getList() {
      const param = {
        page: this.page,
        pageSize: this.pageSize,
      };
      if (this.sortType) {
        param.sort = this.sortType;
      }
      if (this.searchKey) {
        param.searchKey = this.searchKey;
      }
      if (this.classId && this.classId != "all") {
        param.type_id = this.classId;
      }
      if (this.subClassId && this.subClassId != "all") {
        param.subclass_id = this.subClassId;
      }
      if (this.classId == "1") {
        param.recommend = 1;
        delete param.type_id;
      }
      this.$axios.post("/index/Lucky/skinList", this.$qs.stringify(param)).then((res) => {
        if (res.data.status == "1") {
          this.list = res.data.data.list.map((item) => ({
            ...item,
            imageUrl: this.skinImageCache[item.id] || item.imageUrl,
          }));
        }
      });
    },
    selOran(status, id) {
      this.recommend = status == 2 ? 1 : 2;
      this.sortType = "";
      this.classId = id;
      this.getList();
    },
    selClass(item) {
      this.subClassId = item.id;
      this.getList();
    },
    goOrnamentOpen(item) {
      this.$router.push({ path: "/OrnamentOpen", query: { skin_id: item.id } });
    },
    goHistory() {
      this.$router.push({ path: "/OrnamentHistory2" });
    },
    goMyHistory() {
      this.$router.push({ path: "/OrnamentHistory" });
    },
    showGuide() {
      this.$message({
        message: "选择库存饰品或余额，再从下方列表选择目标饰品。升级前请确认所选内容和页面显示的成功机会。",
        type: "info",
      });
    },
    useSkinFallback(event, index) {
      event.target.src = this.skinFallbackImages[index % this.skinFallbackImages.length];
    },
    moneyText(value) {
      return Number(value || 0).toFixed(2);
    },
  },
};
</script>

<style lang="less" scoped>
.upgrade-page {
  min-height: calc(100vh - 198px);
  padding: 34px 34px 90px;
  color: #f5f7ff;
  background:
    radial-gradient(circle at 48% 0, rgba(255, 138, 31, 0.16), transparent 30%),
    radial-gradient(circle at 84% 28%, rgba(0, 217, 255, 0.1), transparent 28%),
    linear-gradient(180deg, #1f212d 0%, #171923 100%);
}

button {
  font-family: inherit;
  cursor: pointer;
}

.upgrade-hero,
.upgrade-filter,
.target-list,
.empty-card {
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
}

.upgrade-hero {
  padding: 34px;
  overflow: hidden;
  border-radius: 18px;
  background:
    linear-gradient(130deg, rgba(41, 43, 58, 0.96), rgba(24, 26, 36, 0.98)),
    url("../assets/new/task_bg.png") center / cover;
  border: 1px solid rgba(255, 132, 31, 0.28);
  box-shadow: 0 26px 80px rgba(0, 0, 0, 0.34);
}

.hero-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
}

.hero-title span,
.upgrade-side > span,
.range-line {
  color: #ff8a1f;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

.hero-title h1 {
  flex: 1;
  margin: 0;
  color: #f8fbff;
  font-size: 54px;
  line-height: 1;
  font-weight: 1000;
}

.hero-title button,
.sort-btn {
  height: 42px;
  padding: 0 18px;
  color: #151620;
  background: linear-gradient(180deg, #ffd53b, #ff8300);
  border: 0;
  border-radius: 7px;
  font-weight: 1000;
}

.upgrade-board {
  margin-top: 28px;
  display: grid;
  grid-template-columns: 1fr 300px 1fr;
  gap: 18px;
  align-items: stretch;
}

.upgrade-side,
.upgrade-center {
  min-height: 264px;
  padding: 20px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.035);
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.empty-inventory {
  height: 150px;
  margin-top: 16px;
  display: grid;
  place-items: center;
  text-align: center;
  border-radius: 12px;
  background: radial-gradient(circle at 50% 40%, rgba(129, 73, 255, 0.24), transparent 62%), #202330;
  border: 1px dashed rgba(255, 255, 255, 0.12);
}

.empty-inventory b {
  display: block;
  color: #f8fbff;
  font-size: 20px;
  font-weight: 1000;
}

.empty-inventory p {
  max-width: 260px;
  margin: 8px auto 0;
  color: #9fa8bb;
  font-size: 13px;
  line-height: 1.6;
  font-weight: 800;
}

.selected-line {
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  gap: 16px;
  color: #9fa8bb;
  font-size: 13px;
  font-weight: 900;
}

.selected-line strong,
.target-card span {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #ffd764;
  font-size: 18px;
  font-weight: 1000;
}

.selected-line i,
.target-card i {
  width: 17px;
  height: 17px;
  display: inline-block;
  background: url("../assets/pizzaking/pizza-token.svg") center / contain no-repeat;
}

.upgrade-center {
  display: grid;
  place-items: center;
  text-align: center;
}

.chance-dial {
  width: 148px;
  height: 148px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background:
    conic-gradient(from 180deg, rgba(255, 138, 0, 0.92), rgba(0, 217, 255, 0.82), rgba(255, 138, 0, 0.92)),
    #202330;
  box-shadow: 0 0 46px rgba(255, 138, 0, 0.2);
}

.dial-core {
  width: 104px;
  height: 104px;
  display: grid;
  place-items: center;
  color: #f8fbff;
  background: #202330;
  border-radius: 50%;
  font-size: 28px;
  font-weight: 1000;
}

.arrow-row {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #f8fbff;
  font-size: 14px;
  font-weight: 1000;
}

.arrow-row span {
  width: 60px;
  height: 2px;
  background: linear-gradient(90deg, transparent, #ff8a1f);
}

.arrow-row span:last-child {
  background: linear-gradient(90deg, #ff8a1f, transparent);
}

.upgrade-filter {
  margin-top: 22px;
  padding: 18px;
  border-radius: 14px;
  background: linear-gradient(180deg, rgba(43, 45, 59, 0.95), rgba(31, 33, 45, 0.98));
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.type-strip,
.subclass-strip,
.filter-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.type-strip button {
  min-width: 116px;
  height: 80px;
  padding: 8px 12px;
  color: #9ea7ba;
  background: #242735;
  border: 1px solid rgba(255, 255, 255, 0.055);
  border-radius: 9px;
  font-weight: 1000;
}

.type-strip img {
  max-width: 68px;
  height: 38px;
  display: block;
  margin: 0 auto 6px;
  object-fit: contain;
}

.type-strip button.active,
.subclass-strip button.active {
  color: #151620;
  background: linear-gradient(180deg, #ffd53b, #ff8300);
  border-color: transparent;
}

.subclass-strip {
  margin-top: 12px;
}

.subclass-strip button {
  height: 38px;
  padding: 0 16px;
  color: #f4f6ff;
  background: #292c3a;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 7px;
  font-weight: 1000;
}

.filter-actions {
  margin-top: 16px;
  align-items: center;
  justify-content: space-between;
}

.upgrade-search {
  width: 360px;
}

.upgrade-search /deep/ .el-input__inner {
  color: #f4f6ff;
  background: #1b1d28;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.target-list {
  margin-top: 22px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(176px, 1fr));
  gap: 12px;
}

.target-card {
  min-height: 232px;
  padding: 12px;
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  background: linear-gradient(180deg, #2b2e3d, #242735);
  border: 1px solid rgba(255, 255, 255, 0.055);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.035);
  transition: transform 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;
  cursor: pointer;
}

.target-card:hover {
  transform: translateY(-2px);
  border-color: rgba(255, 138, 0, 0.5);
  box-shadow: 0 20px 44px rgba(0, 0, 0, 0.26), 0 0 28px rgba(255, 138, 0, 0.13);
}

.target-card em {
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 2;
  padding: 3px 8px;
  color: #ffce70;
  background: rgba(0, 0, 0, 0.25);
  border-radius: 99px;
  font-size: 11px;
  font-style: normal;
  font-weight: 900;
}

.skin-visual {
  height: 132px;
  display: grid;
  place-items: center;
  position: relative;
}

.skin-visual::before {
  content: "";
  width: 150px;
  height: 98px;
  position: absolute;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(120, 72, 255, 0.28), transparent 68%);
}

.skin-visual img {
  max-width: 150px;
  max-height: 102px;
  position: relative;
  object-fit: contain;
  filter: drop-shadow(0 16px 20px rgba(0, 0, 0, 0.46));
}

.target-card strong {
  min-height: 38px;
  display: block;
  overflow: hidden;
  color: #f5f7ff;
  font-size: 14px;
  line-height: 1.35;
  font-weight: 1000;
}

.target-card span {
  margin-top: 10px;
}

.empty-card {
  margin-top: 18px;
  padding: 34px 18px;
  color: #929bad;
  text-align: center;
  background: #242735;
  border: 1px solid rgba(255, 255, 255, 0.055);
  border-radius: 10px;
  font-size: 14px;
  font-weight: 800;
}

@media screen and (max-width: 1080px) {
  .upgrade-page {
    padding: 20px 12px 64px;
  }

  .upgrade-board {
    grid-template-columns: 1fr;
  }

  .hero-title {
    display: grid;
  }

  .hero-title h1 {
    font-size: 46px;
  }

  .upgrade-search {
    width: 100%;
  }
}
</style>

<style lang="less">
.upgrade-page.pk-account-panel {
  padding: 32px 28px 96px !important;
}

.upgrade-page.pk-account-panel .upgrade-hero,
.upgrade-page.pk-account-panel .upgrade-filter,
.upgrade-page.pk-account-panel .target-list,
.upgrade-page.pk-account-panel .empty-card {
  width: calc(100% - 24px) !important;
  max-width: 1540px !important;
}

.upgrade-page.pk-account-panel .upgrade-hero {
  padding: 34px 38px 38px !important;
  background:
    radial-gradient(ellipse at 50% 58%, rgba(255, 176, 55, 0.12), transparent 42%),
    radial-gradient(circle at 86% 10%, rgba(30, 211, 237, 0.13), transparent 24%),
    linear-gradient(130deg, rgba(43, 45, 60, 0.98), rgba(24, 26, 36, 0.99)) !important;
  border-color: rgba(255, 132, 31, 0.38) !important;
  box-shadow:
    0 28px 90px rgba(0, 0, 0, 0.38),
    inset 0 1px 0 rgba(255, 224, 170, 0.08) !important;
}

.upgrade-page.pk-account-panel .upgrade-board {
  grid-template-columns: minmax(300px, 1fr) 360px minmax(300px, 1fr) !important;
  gap: 22px !important;
}

.upgrade-page.pk-account-panel .upgrade-side,
.upgrade-page.pk-account-panel .upgrade-center {
  min-height: 328px !important;
  background:
    radial-gradient(ellipse at 50% 56%, rgba(255, 132, 31, 0.08), transparent 58%),
    rgba(255, 255, 255, 0.035) !important;
  border-color: rgba(111, 121, 151, 0.24) !important;
}

.upgrade-page.pk-account-panel .chance-dial {
  width: 178px !important;
  height: 178px !important;
  box-shadow:
    0 0 54px rgba(255, 138, 0, 0.24),
    0 0 36px rgba(0, 217, 255, 0.14) !important;
}

.upgrade-page.pk-account-panel .dial-core {
  width: 122px !important;
  height: 122px !important;
  font-size: 32px !important;
}

.upgrade-page.pk-account-panel .upgrade-filter {
  padding: 20px !important;
  border-color: rgba(111, 121, 151, 0.22) !important;
}

.upgrade-page.pk-account-panel .type-strip button {
  min-width: 132px !important;
  height: 84px !important;
  background: #282b39 !important;
}

.upgrade-page.pk-account-panel .type-strip button.active,
.upgrade-page.pk-account-panel .subclass-strip button.active {
  color: #20170c !important;
  box-shadow: 0 12px 26px rgba(255, 132, 31, 0.24) !important;
}

.upgrade-page.pk-account-panel .target-list {
  grid-template-columns: repeat(auto-fill, minmax(206px, 1fr)) !important;
  gap: 14px !important;
}

.upgrade-page.pk-account-panel .target-card {
  min-height: 262px !important;
  padding: 14px !important;
  background:
    radial-gradient(ellipse at 50% 44%, rgba(128, 72, 255, 0.22), transparent 58%),
    linear-gradient(180deg, #2b2e3d, #242735) !important;
}

.upgrade-page.pk-account-panel .skin-visual {
  height: 156px !important;
}

.upgrade-page.pk-account-panel .skin-visual::before {
  width: 178px !important;
  height: 112px !important;
  background: radial-gradient(circle, rgba(255, 132, 31, 0.16), rgba(120, 72, 255, 0.28), transparent 68%) !important;
  filter: blur(2px) !important;
}

.upgrade-page.pk-account-panel .skin-visual img {
  max-width: 178px !important;
  max-height: 118px !important;
}

.upgrade-page.pk-account-panel .target-card strong {
  font-size: 15px !important;
}

@media screen and (max-width: 1080px) {
  .upgrade-page.pk-account-panel {
    padding: 20px 12px 72px !important;
  }

  .upgrade-page.pk-account-panel .upgrade-hero,
  .upgrade-page.pk-account-panel .upgrade-filter,
  .upgrade-page.pk-account-panel .target-list,
  .upgrade-page.pk-account-panel .empty-card {
    width: 100% !important;
    max-width: 100% !important;
  }

  .upgrade-page.pk-account-panel .upgrade-board {
    grid-template-columns: 1fr !important;
  }

  .upgrade-page.pk-account-panel .target-list {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
}

/* 2026-07-05 exact-pass: upgrades page width, stage density and target-like controls. */
.upgrade-page.pk-account-panel {
  min-height: calc(100vh - 199px) !important;
  padding: 24px 24px 96px !important;
  background:
    radial-gradient(ellipse at 50% 170px, rgba(255, 138, 31, 0.08), transparent 420px),
    linear-gradient(180deg, #20222f 0, #1c1e29 420px, #171923 100%) !important;
}

.upgrade-page.pk-account-panel .upgrade-hero,
.upgrade-page.pk-account-panel .upgrade-filter,
.upgrade-page.pk-account-panel .target-list,
.upgrade-page.pk-account-panel .empty-card {
  width: 100% !important;
  max-width: none !important;
  box-sizing: border-box !important;
}

.upgrade-page.pk-account-panel .upgrade-hero {
  min-height: 398px !important;
  padding: 24px 26px 28px !important;
  border-radius: 0 !important;
  border: 0 !important;
  background:
    radial-gradient(ellipse at 50% 66%, rgba(255, 184, 67, 0.15), transparent 42%),
    radial-gradient(ellipse at 50% 42%, rgba(37, 210, 237, 0.12), transparent 42%),
    #20222f !important;
  box-shadow: none !important;
}

.upgrade-page.pk-account-panel .hero-title {
  height: 50px !important;
  margin-bottom: 12px !important;
}

.upgrade-page.pk-account-panel .hero-title h1 {
  color: #f4ead8 !important;
  font-size: 24px !important;
  line-height: 50px !important;
  font-weight: 900 !important;
}

.upgrade-page.pk-account-panel .hero-title p {
  color: #8c95a8 !important;
  font-size: 13px !important;
}

.upgrade-page.pk-account-panel .upgrade-board {
  min-height: 306px !important;
  grid-template-columns: minmax(320px, 1fr) 330px minmax(320px, 1fr) !important;
  gap: 16px !important;
  align-items: stretch !important;
}

.upgrade-page.pk-account-panel .upgrade-side,
.upgrade-page.pk-account-panel .upgrade-center {
  min-height: 306px !important;
  border: 1px solid rgba(67, 73, 96, 0.72) !important;
  border-radius: 8px !important;
  background:
    radial-gradient(ellipse at 50% 55%, rgba(236, 216, 184, 0.055), transparent 64%),
    #252837 !important;
}

.upgrade-page.pk-account-panel .upgrade-side > span {
  color: #8f98aa !important;
  font-size: 13px !important;
  font-weight: 900 !important;
  text-transform: uppercase !important;
}

.upgrade-page.pk-account-panel .upgrade-side .empty-slot {
  width: 168px !important;
  height: 168px !important;
  border-radius: 50% !important;
  border: 1px dashed rgba(236, 216, 184, 0.32) !important;
  background:
    radial-gradient(circle, rgba(255, 138, 31, 0.08), transparent 62%),
    #20222f !important;
}

.upgrade-page.pk-account-panel .chance-dial {
  width: 188px !important;
  height: 188px !important;
  border: 1px solid rgba(236, 216, 184, 0.28) !important;
  background:
    radial-gradient(circle, rgba(255, 138, 31, 0.18), transparent 62%),
    conic-gradient(from 0deg, rgba(255, 138, 31, 0.9), rgba(37, 210, 237, 0.75), rgba(67, 73, 96, 0.75), rgba(255, 138, 31, 0.9)) !important;
}

.upgrade-page.pk-account-panel .dial-core {
  color: #fff7df !important;
  background: #20222f !important;
  border: 1px solid rgba(236, 216, 184, 0.2) !important;
}

.upgrade-page.pk-account-panel .upgrade-filter {
  margin-top: 18px !important;
  padding: 14px 16px !important;
  border: 1px solid #2b2d3c !important;
  border-radius: 8px !important;
  background: #20222f !important;
}

.upgrade-page.pk-account-panel .type-strip,
.upgrade-page.pk-account-panel .subclass-strip {
  gap: 8px !important;
}

.upgrade-page.pk-account-panel .type-strip button {
  min-width: 116px !important;
  height: 66px !important;
  border-radius: 7px !important;
  color: #aab3c4 !important;
  border: 1px solid rgba(67, 73, 96, 0.7) !important;
  background: #252837 !important;
}

.upgrade-page.pk-account-panel .type-strip button.active,
.upgrade-page.pk-account-panel .subclass-strip button.active {
  color: #fff7df !important;
  background: linear-gradient(180deg, #ff971f, #f26b00) !important;
}

.upgrade-page.pk-account-panel .upgrade-search /deep/ .el-input__inner {
  height: 46px !important;
  color: #d8deea !important;
  border-color: rgba(67, 73, 96, 0.7) !important;
  background: #252837 !important;
}

.upgrade-page.pk-account-panel .target-list {
  margin-top: 18px !important;
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr)) !important;
  gap: 10px !important;
}

.upgrade-page.pk-account-panel .target-card {
  min-height: 242px !important;
  border-radius: 8px !important;
  border-color: rgba(67, 73, 96, 0.68) !important;
  background:
    radial-gradient(ellipse at 50% 38%, rgba(127, 72, 255, 0.24), transparent 56%),
    #252837 !important;
  box-shadow: none !important;
}

.upgrade-page.pk-account-panel .skin-visual {
  height: 140px !important;
}

.upgrade-page.pk-account-panel .skin-visual img {
  max-width: 164px !important;
  max-height: 110px !important;
}

.upgrade-page.pk-account-panel .target-card strong {
  min-height: 36px !important;
  color: #f4ead8 !important;
  font-size: 13px !important;
}

/* 2026-07-20 target structure pass: stage, direction, multiplier and history controls. */
.upgrade-page.pk-account-panel .upgrade-hero {
  padding: 0 26px 26px !important;
  background: #20222f !important;
}

.upgrade-page.pk-account-panel .hero-title {
  height: 92px !important;
  margin: 0 !important;
  border-bottom: 1px solid #2b2d3c !important;
}

.upgrade-page.pk-account-panel .hero-title-copy,
.upgrade-page.pk-account-panel .history-actions,
.upgrade-page.pk-account-panel .source-switch,
.upgrade-page.pk-account-panel .roll-direction,
.upgrade-page.pk-account-panel .multiplier-control,
.upgrade-page.pk-account-panel .balance-control {
  display: flex;
  align-items: center;
}

.upgrade-page.pk-account-panel .hero-title-copy {
  gap: 13px;
}

.upgrade-page.pk-account-panel .upgrade-title-icon {
  width: 34px;
  height: 34px;
  position: relative;
  border: 3px solid #f4ead8;
  border-radius: 50%;
}

.upgrade-page.pk-account-panel .upgrade-title-icon::before,
.upgrade-page.pk-account-panel .upgrade-title-icon::after {
  content: "";
  width: 16px;
  height: 5px;
  position: absolute;
  left: 6px;
  border-radius: 4px;
  background: #f4ead8;
}

.upgrade-page.pk-account-panel .upgrade-title-icon::before { top: 7px; }
.upgrade-page.pk-account-panel .upgrade-title-icon::after { bottom: 7px; }

.upgrade-page.pk-account-panel .hero-title-copy > span:first-child {
  letter-spacing: 0 !important;
}

.upgrade-page.pk-account-panel .guide-button,
.upgrade-page.pk-account-panel .history-actions button {
  height: 40px !important;
  padding: 0 16px !important;
  color: #ecd8b8 !important;
  border: 1px solid rgba(236, 216, 184, 0.38) !important;
  border-radius: 6px !important;
  background: #252837 !important;
  box-shadow: none !important;
}

.upgrade-page.pk-account-panel .history-actions {
  gap: 8px;
}

.upgrade-page.pk-account-panel .upgrade-board {
  min-height: 376px !important;
  margin-top: 18px !important;
  grid-template-columns: minmax(300px, 1fr) 420px minmax(300px, 1fr) !important;
  gap: 0 !important;
  overflow: hidden;
  border: 1px solid #2b2d3c;
  border-radius: 8px;
  background:
    radial-gradient(circle at 50% 45%, rgba(67, 88, 255, 0.24), transparent 24%),
    linear-gradient(90deg, #181a25 0%, #202330 32%, #202330 68%, #181a25 100%);
}

.upgrade-page.pk-account-panel .upgrade-side,
.upgrade-page.pk-account-panel .upgrade-center {
  min-height: 376px !important;
  border: 0 !important;
  border-radius: 0 !important;
  background: transparent !important;
}

.upgrade-page.pk-account-panel .upgrade-center {
  background: linear-gradient(180deg, rgba(51, 56, 78, 0.52), rgba(29, 32, 45, 0.72)) !important;
}

.upgrade-page.pk-account-panel .empty-inventory {
  border: 0 !important;
  background: radial-gradient(circle at 50% 42%, rgba(255, 189, 66, 0.09), transparent 62%) !important;
}

.upgrade-page.pk-account-panel .source-switch {
  width: 210px;
  height: 46px;
  margin: 12px auto 0;
  padding: 3px;
  border-radius: 24px;
  background: #2c303d;
}

.upgrade-page.pk-account-panel .source-switch button {
  width: 50%;
  height: 40px;
  color: #aeb6c5;
  border: 0;
  border-radius: 22px;
  background: transparent;
  font-weight: 900;
}

.upgrade-page.pk-account-panel .source-switch button.active {
  color: #fff7df;
  background: #3a3e4c;
}

.upgrade-page.pk-account-panel .upgrade-controls {
  min-height: 158px;
  margin-top: 14px;
  padding: 14px 22px;
  display: grid;
  grid-template-columns: 1fr 1.5fr 1fr;
  align-items: center;
  gap: 26px;
  border: 1px solid #2b2d3c;
  border-radius: 8px;
  background: #1d1f2a;
}

.upgrade-page.pk-account-panel .roll-direction {
  justify-content: flex-end;
}

.upgrade-page.pk-account-panel .roll-direction button {
  min-width: 120px;
  height: 36px;
  color: #dfe3ec;
  border: 1px solid #4a5063;
  background: transparent;
  font-weight: 900;
}

.upgrade-page.pk-account-panel .roll-direction button:first-child { border-radius: 20px 0 0 20px; }
.upgrade-page.pk-account-panel .roll-direction button:last-child { border-radius: 0 20px 20px 0; }
.upgrade-page.pk-account-panel .roll-direction button.active { color: #fff; background: #8466ff; border-color: #8466ff; }

.upgrade-page.pk-account-panel .multiplier-control {
  justify-content: center;
  gap: 10px;
}

.upgrade-page.pk-account-panel .multiplier-control > span {
  color: #aeb6c5;
  font-size: 11px;
  line-height: 12px;
}

.upgrade-page.pk-account-panel .multiplier-control > span:last-child { text-align: right; }
.upgrade-page.pk-account-panel .multiplier-control b { color: #fff7df; }

.upgrade-page.pk-account-panel .multiplier-control button {
  min-width: 58px;
  height: 30px;
  color: #fff;
  border: 2px solid #eef1f7;
  border-radius: 16px;
  background: transparent;
  font-weight: 900;
}

.upgrade-page.pk-account-panel .multiplier-control button.active { border-color: #8466ff; background: #8466ff; }

.upgrade-page.pk-account-panel .balance-control {
  gap: 12px;
  color: #aeb6c5;
  font-size: 12px;
}

.upgrade-page.pk-account-panel .balance-control > div {
  width: 190px;
  height: 5px;
  position: relative;
  border-radius: 4px;
  background: #7561d9;
}

.upgrade-page.pk-account-panel .balance-control > div i {
  width: 20px;
  height: 20px;
  position: absolute;
  left: 0;
  top: -8px;
  border-radius: 50%;
  background: #8c6cff;
}

.upgrade-page.pk-account-panel .balance-control > b {
  min-width: 42px;
  padding: 5px 8px;
  color: #fff;
  border-radius: 4px;
  background: #8b8f99;
  text-align: center;
}

@media screen and (max-width: 1080px) {
  .upgrade-page.pk-account-panel .hero-title {
    height: auto !important;
    padding: 18px 0 !important;
  }

  .upgrade-page.pk-account-panel .upgrade-controls {
    grid-template-columns: 1fr;
  }

  .upgrade-page.pk-account-panel .roll-direction,
  .upgrade-page.pk-account-panel .balance-control {
    justify-content: center;
  }
}
</style>
